/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Scim_Enterprise_Required_TitleInputs */



/**
* | output |
* | --- |
* | "Enterprise Plan Required" |
*
* @param {Admin_Settings_Scim_Enterprise_Required_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_settings_scim_enterprise_required_title = /** @type {((inputs?: Admin_Settings_Scim_Enterprise_Required_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Scim_Enterprise_Required_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Enterprise-Plan erforderlich")
	return /** @type {LocalizedString} */ ("Enterprise Plan Required")
});